import { genericRoute } from 'utils/routeUtils';

import RugbyUnionHomePage from './containers/RugbyUnionHomePage';
import RugbyUnionNav from './nav/RugbyUnionNav';

export default genericRoute(RugbyUnionHomePage, RugbyUnionNav, 'rugby-union');



// WEBPACK FOOTER //
// ./modules/RugbyUnion/routes.js